true<template>
    <v-container id="overviews" fluid>
        <!-- >>> Card: YearCalendar ---------------------------------------- -->
        <v-card style="height: 100%">
            <YearCalendar
                v-model="year"
                :activeDates="combinedVacationsAndMarkedDates"
                :activeClass="activeClass"
                prefixClass="your_customized_wrapper_class"
                @toggleDate="toggleDate"
                @monthClick="monthClick">
            </YearCalendar>
        </v-card>
        <!-- <<< Card: YearCalendar ---------------------------------------- -->




        <!-- >>> Floating 'Create' Button -->
		<v-fab-transition>
			<v-btn :disabled="isCreateButton_Disabled()" fab fixed color="primary" bottom right style="margin-bottom: 50px; margin-right: 50px;" @click="onClick_FloatingButton_Create()">
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</v-fab-transition>
		<!-- <<< Floating 'Create' Button -->

        <!-- >>> Floating 'Update' Button -->
		<v-fab-transition>
			<v-btn v-if="get_shared_IsDutyAccessAllowed === true" :disabled="isUpdateButton_Disabled()" fab fixed color="primary" bottom right style="margin-bottom: 50px; margin-right: 120px;" @click="onClick_FloatingButton_Update()">
				<v-icon>mdi-pencil</v-icon>
			</v-btn>
		</v-fab-transition>
		<!-- <<< Floating 'Update' Button -->

        <!-- >>> Floating 'Delete' Button -->
		<v-fab-transition>
			<v-btn v-if="get_shared_IsDutyAccessAllowed === true" :disabled="isDeleteButton_Disabled()" fab fixed color="red" bottom right style="margin-bottom: 50px; margin-right: 210px;" @click="onClick_FloatingButton_Delete()">
				<v-icon>mdi-delete-outline</v-icon>
			</v-btn>
		</v-fab-transition>
		<!-- <<< Floating 'Delete' Button -->




        <!-- >>> Sdr-Component, BottomSheet -------------------------------- -->
		<sdr-vacations-bottom-sheet
			v-model="showSheet"
			:editorMode="editorMode"
			:createMode="createMode"
            :selectedDates="selectedDatesForSheet"
			:resourcePrefillObject="resourcePrefillObject">
		</sdr-vacations-bottom-sheet>




        <!-- >>> Sdr-Component, DeleteAlert -------------------------------- -->
        <sdr-vacations-delete-alert
            v-model="showDeleteAlert"
            :selectedDates="selectedDates.filter(d => d.id !== null)">
        </sdr-vacations-delete-alert>
    </v-container>
</template>


<script>
    import Vue from 'vue';
    import YearCalendar from 'vue-material-year-calendar';
    import VacationsBottomSheet from './components/core/BottomSheet.vue';
    import VacationsDeleteAlert from './components/core/DeleteAlert.vue';

    import { mapActions, mapGetters } from "vuex";

    import { eventBus } from '../../../main';
    import dayjs from 'dayjs';


    export default {
        name: 'VacationsHome',

		/* >>> *************************************************************** / /* Components */
		components: {

            'sdr-vacations-bottom-sheet': VacationsBottomSheet,
            'sdr-vacations-delete-alert': VacationsDeleteAlert,
			YearCalendar

		}, // eo components{}
		/* <<< ****************************************************************/



		/* >>> *************************************************************** / /* Data */
		data: function() {

            return {
                year: dayjs().year(),
                activeClass: '',
                // >>> ------------------------------------
                floatingButtonDisabled: true,
                // >>> ------------------------------------
				showSheet : false,
				editorMode : null, // 'update, create'
				createMode : null, // 'multibreaks', 'singlebreaks'
                selectedDatesForSheet: [], // for AddAlert
				resourcePrefillObject : null,
                // >>> ------------------------------------
                showDeleteAlert: false,
                selectedDates: [], // for AddAlert
            };

        },  // eo data{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
				'get_CombinedVacationsOfResource',
                'get_idResource',
                'getIdGroup',
                'get_shared_IsDutyAccessAllowed',
                'get_shared_IsEditingInThePastAllowed' // #4
			]),


            /*******************************************************************
            * combinedVacationsAndMarkedDates()
            *
            * Desc:
            * Note:
            *
            */
            combinedVacationsAndMarkedDates: {

                get() {

                    let me = this,
                        dates = [];


                    me.$toc('>>> views/vacations/vacations/Home.vue >>> combinedVacationsAndMarkedDates computed');
                    // take every date, which is already marked as vacation/offday/illness
                    // and add selected class, if this date is included in selectedDates too
                    me.get_CombinedVacationsOfResource.forEach((date) => {
                        if (me.selectedDates.findIndex(d => d.date === date.date) > -1 && ( date.className.includes('vacation') || date.className.includes('unabletofly') || date.className.includes('dayoff'))) {
                            dates.push({ date: date.date, className: `${date.className} selected`, id: date.id, comment: date.comment });
                        } else {
                            dates.push(date);
                        }
                    });

                    // add up every other selected date, which is not highlighted as
                    // vacation/offday/illness
                    me.selectedDates.forEach((date) => {
                        if (dates.findIndex(d => d.date === date.date) === -1) {
                            // this date is not included in dates-array, but is selected by user
                            dates.push({ date: date.date, className: "selected", id: null });
                        }
                    });


                    dates.sort((a, b) => a.date < b.date ? -1 : 1);


                    return dates;

                } // eo function combinedVacationsAndMarkedDates get()

            } // eo function combinedVacationsAndMarkedDates{}

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /*******************************************************************
            * year()
            *
            * Desc:
            * Note: Emit 'Year has changed'.
            *
            */
            year (val) {

                const me = this;


                me.$toc('>>> views/vacations/vacations/Home.vue >>> year watch');
                eventBus.$emit('yearwaschanged', val);
                this.selectedDates = [];

            } // eo function year()

        }, //  eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc: Load the 2 Department Calls in parallel.
        * Note: 'Cabin', 'Cockpit'
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/vacations/vacations/Home.vue >>> created');
			this.actn_call_getResourcesOfDepartment({ department: '11', secondLoad: false });
			this.actn_call_getResourcesOfDepartment({ department: '12', secondLoad: true });

            this.actn_call_load_AllEmployees({});  // all employees

            eventBus.$on('combinedvacationsdone', this.onDone_combinedVacationsDone); // TODO: off
            eventBus.$on('deleteVacationsDone', this.onDone_deleteVacationsDone);

            eventBus.$on('resetcalendar', this.onEmit_resetCalendar);

		}, // eo function created()


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/vacations/vacations/Home.vue >>> destroyed');
            eventBus.$off('combinedvacationsdone', this.onDone_combinedVacationsDone); // TODO: off
            eventBus.$off('deleteVacationsDone', this.onDone_deleteVacationsDone);

            eventBus.$off('resetcalendar', this.onEmit_resetCalendar);

		}, // eo function created()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([
				'actn_call_getResourcesOfDepartment',
                'actn_call_load_AllEmployees',
			]),


            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/
			/*******************************************************************
			* onClick_FloatingButton_Create()
			*
			* Desc:
            * Note: Ticket ##630 (only 1 Craete Sheet).
            * Note: Ticket #4 (Subsequent changes)
			*
			*/
            onClick_FloatingButton_Create: function() {

                const me = this;
                let gotSelectedDates = me.selectedDates.filter(d => d.id === null).length > 0,
                    createModeLocal = gotSelectedDates === false ? 'singlebreaks' : 'multibreaks';


                me.$toc('>>> views/vacations/vacations/Home.vue >>> onClick_FloatingButton_Create');
                // >>> Guard Clause >>> ------------------- #4
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: me.selectedDates, isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.resourcePrefillObject = null; // reset
                this.selectedDatesForSheet = me.selectedDates;

                this.editorMode = 'create'; // set 'mode' & 'value
                this.createMode = createModeLocal; // set 'mode' & 'value'

                this.showSheet = true;

			}, // eo function onClick_FloatingButton_Create()

            /*******************************************************************
			* onClick_FloatingButton_Delete()
			*
			* Desc:
            * Note: Ticket #4 (Subsequent changes)
            *
			*/
            onClick_FloatingButton_Delete: function() {

                const me = this;


                me.$toc('>>> views/vacations/vacations/Home.vue >>> onClick_FloatingButton_Delete');
                // >>> Guard Clause >>> ------------------- #4
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: me.selectedDates.filter(d => d.id !== null), isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


				me.showDeleteAlert = true;

			}, // eo function onClick_FloatingButton_Delete()

            /*******************************************************************
			* onClick_FloatingButton_Update()
			*
			* Desc:
            * Note: Ticket #4 (Subsequent changes)
            *
			*/
            onClick_FloatingButton_Update: function() {

                const me = this;
                    let createModeLocal = 'multibreaks'; // 'singlebreaks' : 'multibreaks'


                me.$toc('>>> views/vacations/vacations/Home.vue >>> onClick_FloatingButton_Update');
                // >>> Guard Clause >>> ------------------- #4
                if (!Vue.prototype.$isActionAllowed({ datesToCheck: me.selectedDates, isAdmin: this.get_shared_IsEditingInThePastAllowed })) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'Note: Dear User, no Changes in Past possible.'
                    });
                    return;
                }


                this.resourcePrefillObject = me.selectedDates; // selected Dates/Objects
                this.selectedDatesForSheet = me.selectedDates;

                this.editorMode = 'update'; // set 'mode' & 'value
                this.createMode = createModeLocal; // set 'mode' & 'value'

                this.showSheet = true;

            }, // eo function onClick_FloatingButton_Update()




            /*******************************************************************
			* onDone_combinedVacationsDone()
			*
			* Desc:
			*
			*/
            onDone_combinedVacationsDone: function() {

                const me = this;


                me.$toc('>>> views/vacations/vacations/Home.vue >>> onDone_combinedVacationsDone');
                me.floatingButtonDisabled = false;
                me.selectedDates = []; // reset

            }, // eo function onDone_combinedVacationsDone()


            /*******************************************************************
			* onDone_deleteVacationsDone()
			*
			* Desc:
			*
			*/
            onDone_deleteVacationsDone: function() {

                const me = this;


                me.$toc('>>> views/vacations/vacations/Home.vue >>> onDone_deleteVacationsDone');
                me.selectedDates = [];

            }, // eo function onDone_deleteVacationsDone()


            /*******************************************************************
            * toggleDate()
            *
            * Desc:
            * Note:
            *
            */
            toggleDate: function(dateInfo) {

                const me = this;
                let index = me.selectedDates.findIndex(item => item.date === dateInfo.date),
                    dateObject = me.get_CombinedVacationsOfResource.find(d => d.date === dateInfo.date);


                me.$toc('>>> views/vacations/vacations/Home.vue >>> toggleDate');
                // protector: stop if user is not allowed to modify the calendar
                // if (me.get_shared_IsDutyAccessAllowed !== true) {
                //     return;
                // }

                // protector: stop if there is no resource selected
                if (me.get_idResource === null) {
                    return;
                }


                // is selected date a free (non off) day?
                if (dateObject === undefined) {
                    if (index > -1) {
                        me.selectedDates.splice(index, 1);
                    } else {
                        me.selectedDates.push({ ...dateInfo, id: null, type: 'FREE' });
                    }
                }

                // is selected date a vacation day?
                if (dateObject) {
                    if (dateObject.className === 'vacation') {
                        if (index > -1) {
                            me.selectedDates.splice(index, 1);
                        } else {
                            me.selectedDates.push({ ...dateInfo, id: dateObject.id, type: 'VACATION', comment: dateObject.comment });
                        }
                    }
                }

                // is selected date a unbaletofly day?
                if (dateObject) {
                    if (dateObject.className === 'unabletofly') {
                        if (index > -1) {
                            me.selectedDates.splice(index, 1);
                        } else {
                            me.selectedDates.push({ ...dateInfo, id: dateObject.id, type: 'UNABLETOFLY', comment: dateObject.comment });
                        }
                    }
                }

                // is selected date a dayoff day?
                if (dateObject) {
                    if (dateObject.className === 'dayoff') {
                        if (index > -1) {
                            me.selectedDates.splice(index, 1);
                        } else {
                            me.selectedDates.push({ ...dateInfo, id: dateObject.id, type: 'DAYOFF', comment: dateObject.comment });
                        }
                    }
                }


                me.selectedDates.sort((a, b) => a.date < b.date ? -1 : 1);

            }, // eo function toggleDate()


            /*******************************************************************
            * monthClick()
            *
            * Desc:
            * Note: Not used right now.
            *
            */
            monthClick: function(monthYearInfo) {

                // console.log(monthYearInfo);

            }, // eo function monthClick()




            /*******************************************************************
            * isCreateButton_Disabled()
            *
            * Desc:
            * Note: Button is disabled if there are dates selected for delete AND dates selected to add.
            * Note: id === null - date to add
            * Note: id !== null - date to delete
            *
            */
            isCreateButton_Disabled: function() {

                const me = this;
                let buttonDisabled = me.floatingButtonDisabled;


                me.$toc('>>> views/vacations/vacations/Home.vue >>> isCreateButton_Disabled');
                if (me.selectedDates.some(d => d.id === null)) {
                    buttonDisabled = false;
                }

                if (me.selectedDates.some(d => d.id !== null)) {
                    buttonDisabled = true;
                }

                if (me.get_idResource === null) { // Case: Member by User Deleted
                    buttonDisabled = true;
                }


                return buttonDisabled;

            }, // eo function isCreateButton_Disabled()

            /*******************************************************************
            * isDeleteButton_Disabled()
            *
            * Desc:
            * Note: Button is disabled if there is no date to delete selected OR
            * Note: if there are dates selected for delete AND dates selected to add.
            * Note: id === null - date to add
            * Note: id !== null - date to delete
            *
            */
            isDeleteButton_Disabled: function() {

                const me = this;
                let buttonDisabled = true;


                me.$toc('>>> views/vacations/vacations/Home.vue >>> isDeleteButton_Disabled');
                if (me.selectedDates.some(d => d.id !== null)) {
                    buttonDisabled = false;
                }

                if (me.selectedDates.some(d => d.id === null)) {
                    buttonDisabled = true;
                }


                return buttonDisabled;

            }, // eo function isDeleteButton_Disabled()

            /*******************************************************************
            * isUpdateButton_Disabled()
            *
            * Desc:
            * Note: Button is disabled if there is no date to update OR
            * Note:
            * Mote:
            * Note:
            *
            */
            isUpdateButton_Disabled: function() {

                const me = this;
                let buttonDisabled = true;


                me.$toc('>>> views/vacations/vacations/Home.vue >>> isUpdateButton_Disabled');
                // >>> ------------------------------------
                function allAreEqual() {
                    const result = me.selectedDates.every(element => {
                        if (element.type === me.selectedDates[0].type) {
                            return true;
                        }
                    });

                    return result;
                };


                if (me.selectedDates.some(d => d.type !== null)) {              // a) update - ALLOWED
                    buttonDisabled = false;
                }

                if (me.selectedDates.some(d => d.id === null)) {                // b) update - NOT ALLOWED
                    buttonDisabled = true;
                }

                if (me.selectedDates.some(d => d.id !== null)) {                // c) update - NOT ALLOWED (diff types)
                    if (allAreEqual() === false) {
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Note: Dear User, to update please select only one type.'
                        });
                        buttonDisabled = true;
                    }
                }


                return buttonDisabled;

            }, // eo function isUpdateButton_Disabled()




            /******************************************************************* 'Listeners - Emit'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
			* onEmit_resetCalendar()
			*
			* Desc:
			*
			*/
            onEmit_resetCalendar: function() {

                const me = this;


				me.$toc('>>> views/vacations/vacations/Home.vue >>> onEmit_resetCalendar');
                this.selectedDates = [];

            }, // eo function onEmit_resetCalendar()


            /*******************************************************************
			* onEmit_refreshCalendar()
			*
			* Desc:
			*
			*/
            onEmit_refreshCalendar: function() {

                const me = this;


				me.$toc('>>> views/vacations/vacations/Home.vue >>> onEmit_refreshCalendar');
                this.selectedDates = [];

            } // eo function onEmit_refreshCalendar()

        }
        /* <<< ****************************************************************/
    };
</script>


<style lang="stylus">
    .your_customized_wrapper_class {
        background-color: #0aa;
        color: white;

        &.vacation {
            background-color: #FE31EA;
            color: white;
        }

        &.dayoff {
            background-color: #FFA500;
            color: white;
        }

        &.sickness {
            background-color: #4531FE;
            color: white;
        }

        &.unabletofly {
            background-color: #e53f2c;
            color: white;
        }

        &.selected {
            border: 3px solid green;
        }
    }
</style>
